import React from "react";

const BOT_COMMONS_ATTRIBUTES = Object.freeze({
	"bot-id": "428539f2fb17fab162d7e754dfa9ccba",
	"widget": "true",
	"open": "false",
	"restore-open": "false",
	"tooltip": "Ciao, se hai bisogno di aiuto io sono qui!",
	"z-index": "9999",
	"stomp": "true"
});

export const BOT_TYPES = Object.freeze({
	VENDOR_CHAT: {
		"bot-id": "d34aa04acc3d86c3f9e73c1328ff0437",
        "group-id": "54",
        "widget": BOT_COMMONS_ATTRIBUTES.widget,
        "audio": "false",
        "voice": "false",
        "open": BOT_COMMONS_ATTRIBUTES.open,
        "tooltip": BOT_COMMONS_ATTRIBUTES.tooltip,
        "z-index": BOT_COMMONS_ATTRIBUTES["z-index"]
	}, 
	CHAT: {
		...BOT_COMMONS_ATTRIBUTES,
		"audio": "false",
		"voice": "false",
		"dhi": "false",
		"transparent": "false",
		"avatar-delayed": "false",
		"avatar-wait": "false",
		"allow-switch-interface": "false",
	},
	VOICE: {
		...BOT_COMMONS_ATTRIBUTES,
		"audio": "true",
		"voice": "true",
		"dhi": "true",
		"transparent": "true",
		"avatar-delayed": "true",
		"avatar-wait": "true",
		"allow-switch-interface": "true",
	}
});

export default function AlghoBot({ botType }) {
	React.useEffect(() => {
		// se un'altra istanza ha già caricato il bot non lo si carica di nuovo, altrimenti compaiono più icone della chat
		if (document.getElementById("algho-viewer-module")) return;

		// MAPPA IL BOT DINAMICAMENTE IN BASE AL TIPO
        const tag = document.createElement("algho-viewer");

		Object.keys(botType).forEach(k => {
			tag.setAttribute(k, botType[k]);
		});
		
		document.body.appendChild(tag);

		const isVendorChat = botType["bot-id"] === BOT_TYPES.VENDOR_CHAT["bot-id"];
		const src = isVendorChat
			? "https://virtualassistant.alghoncloud.com/algho-viewer.min.js"
			: "https://virtualassistant.alghoncloud.com/algho-viewer.min.js?autostartEveryTimeQuestionId=1262851";

        const script = document.createElement("script");
        script.setAttribute("id", "algho-viewer-module");
        script.setAttribute("type", "text/javascript");
        script.setAttribute("defer", "defer");
        script.setAttribute("charset", "UTF-8");
        script.setAttribute("src", src);
        document.body.appendChild(script);

        // Cleanup dello script e dell'elemento algho-viewer quando il componente viene smontato
        return () => {
            document.body.removeChild(tag);
            document.body.removeChild(script);
        };
    }, [botType]);

    return null;  // Non renderizza nulla visivamente, si occupa solo dello script.
}